<template>
  <div class="mapbox-search">
    <label for="mapbox_search" class="screenReaderOnly">{{ placeholderText }}</label>
    <autocomplete
      id="mapbox_search"
      :placeholder="placeholder"
      :class="{ hidePlaceholder: hidePlaceholder, expanded: expanded }"
      :url="baseUrl"
      :custom-params="mapboxParams"
      :on-select="handleSelect"
      :on-focus="handleFocus"
      :on-blur="handleBlur"
      :on-error="handleError"
      :debounce="250"
      anchor="text"
      label="place_name"
      name="autocomplete_input"
    />
  </div>
</template>
<script>
import Autocomplete from './Autocomplete';

export default {
  name: 'MapboxSearch',
  components: {
    Autocomplete
  },
  props: {
    showGeolocation: {
      type: Function,
      default: () => {}
    },
    hideGeolocation: {
      type: Function,
      default: () => {}
    },
    updateLocation: {
      type: Function,
      default: () => {}
    },
    hidePlaceholder: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: 'Search a location'
    }
  },
  data() {
    return {
      baseUrl: 'https://api.mapbox.com/geocoding/v5/mapbox.places/',
      searchUrl: '',
      expanded: false,
      mapboxParams: {
        access_token: process.env.MAPBOX_TOKEN,
        autocomplete: true,
        country: 'us',
        types: 'postcode,district,place,locality,neighborhood,address,poi,poi.landmark'
      }
    };
  },
  computed: {
    placeholder () {
      return this.hidePlaceholder ? '' : this.placeholderText;
    }
  },
  methods: {
    handleSelect (data) {
      if (typeof this.updateLocation == 'function') {
        if (!data.center || data.center.length !== 2) return;

        // Turn mapbox [lng, lat] into Leaflet latlng
        let latlng = L.latLng([data.center[1], data.center[0]])
        this.updateLocation(latlng);
      }
    },
    handleFocus (e) {
      this.hideGeolocation();
      if (this.hidePlaceholder) {
        this.expanded = true;
      }
    },
    handleBlur (e) {
      this.showGeolocation();
      if (this.hidePlaceholder) {
        this.expanded = false;
      }
    },
    handleError (err) {
      console.error(err)
    },
    // Template used to render a single autocomplete result
    // (can return html)
    renderChild(data) {
      let result = this.stripCountry(data.place_name)
      return result
    },
    stripCountry(value) {
      if (!value) return ''
      value = value.toString()
      return value.replace(', United States', '')
    }
  }
};
</script>

<style lang="scss">
.mapbox-search {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}
.mq-mobile {
  .hidePlaceholder {
    width: 90px;
    transition: width 0.3s ease-out;

    .autocomplete-input {
      background-position-x: 15px;
    }
  }
  .expanded {
    width: calc(100vw - 30px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MapboxSearch.vue